import type { Jsonable } from '@enterprise/types';

export abstract class BaseError extends Error {
  public readonly context?: Jsonable;

  constructor(message?: string, options?: ErrorOptions) {
    const { cause, context } = options ?? {};

    super(message, { cause });

    this.context = context;
    this.name = 'BaseError';
  }
}
